import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit {
  isDisplayedInLayout: boolean = false;
  hideLayout: boolean = false;
  constructor(private router: Router) {}

  ngOnInit(): void {
    this.checkLayout(this.router.url);
  }

  onDisplayChange(isDisplayed: boolean) {
    this.isDisplayedInLayout = isDisplayed;
  }

  checkLayout(currentRoute: string) {
    this.hideLayout = currentRoute.includes('/print/');
  }
}